import { inject, prop, needs } from "fw";

import { debounce } from "lodash-es";
import { PasswordHint } from "./password-hint";
import { UtilityRepository } from "network/utility-repository";

@inject
@needs(PasswordHint)
export class PasswordStrengthMeter {
    @prop(null) password: string;
    @prop(false) inlineHint!: boolean;

    private strength: number = null;
    private debouncedCheckStrength = null;
    private showInlineHint = false;

    constructor(private utilityRepo: UtilityRepository) {}

    attached() {
        this.debouncedCheckStrength = debounce(this.checkStrength.bind(this), 150);
    }

    passwordChanged() {
        if (this.password == null || this.password.trim().length == 0 || this.debouncedCheckStrength == null) {
            this.strength = null;
            return;
        } else if (this.password.length <= 3) {
            this.strength = 0;
            return;
        }

        this.debouncedCheckStrength();
    }

    async checkStrength() {
        if (this.password == null || this.password.trim().length == 0) {
            this.strength = null;
            return;
        }

        const profile = await this.utilityRepo.checkPasswordStrength(this.password);
        this.strength = profile.Score;
    }

    get description() {
        switch (this.strength) {
            case 0:
            case 1:
                return "Weak Password";
            case 2:
                return "Okay Password";
            case 3:
                return "Good Password";
            case 4:
                return "Strong Password";
            default:
                return "";
        }
    }

    get showHint() {
        if (this.strength == null) return false;
        if (this.strength >= 0 && this.strength < 3) return true;
        return false;
    }
}
